import { i18n } from '@lingui/core';
import { compileMessage } from '@lingui/message-utils/compileMessage';

import { Language, browserLanguage } from './locale';

export async function dynamicActivate(locale: Language) {
  try {
    const { messages } = await import(`../locales/${locale}/messages.ts`);
    i18n.loadAndActivate({ locale, messages });
  } catch (error) {
    console.error(`Failed to load locale '${locale}':`, error);

    const { messages } = await import('../locales/en/messages.ts');
    i18n.loadAndActivate({ locale: 'en', messages });
  }
}

export async function setupI18n() {
  i18n.setMessagesCompiler(compileMessage);

  await dynamicActivate(browserLanguage);
}

export { i18n };
